import { render } from "./SpaDayTreatments.vue?vue&type=template&id=f86e6e38&scoped=true"
import script from "./SpaDayTreatments.vue?vue&type=script&lang=js"
export * from "./SpaDayTreatments.vue?vue&type=script&lang=js"

import "./SpaDayTreatments.vue?vue&type=style&index=0&id=f86e6e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f86e6e38"]])

export default __exports__